// Accessibility enhancements for Bootstrap Offcanvas components
(function () {
  // Unique ID for the live region used for announcements
  var LIVE_REGION_ID = 'ln-a11y-live-region';
  //
  var FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable="true"]'
  ].join(',');
// Check if an element is visible and focusable
  function isVisible(element) {
    if (!element) return false;
    if (element.hidden) return false;
    if (element.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(element);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    return element.getClientRects().length > 0;
  }
// Ensure a live region exists for announcements
  function ensureLiveRegion() {
    var region = document.getElementById(LIVE_REGION_ID);
    if (region) return region;
    region = document.createElement('div');
    region.id = LIVE_REGION_ID;
    region.className = 'visually-hidden';
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    document.body.appendChild(region);
    return region;
  }
// Announce a message via the live region
  function announce(message) {
    if (!message) return;
    var liveRegion = ensureLiveRegion();
    liveRegion.textContent = '';
    // Delay the update to ensure screen readers detect the change
    window.setTimeout(function () {
      liveRegion.textContent = String(message);
    }, 40);
  }
// Get all focusable elements within container that are currently visible
  function getFocusableElements(container) {
    return Array.prototype.slice
      .call(container.querySelectorAll(FOCUSABLE_SELECTOR))
      .filter(function (element) {
        return isVisible(element);
      });
  }
// Normalize a trigger element to a focusable ancestor or return null if no valid trigger is found
  function normalizeTrigger(trigger) {
    if (!trigger || typeof trigger.closest !== 'function') return trigger || null;
    return trigger.closest('button, a, input, select, textarea, [role="button"], [tabindex]') || trigger;
  }
// Determine the initial focus target when a drawer is opened
  function getInitialFocusTarget(drawer) {
    var preferred = drawer.querySelector('[data-drawer-initial-focus]');
    if (preferred && isVisible(preferred)) return preferred;

    var focusable = getFocusableElements(drawer);
    if (focusable.length) return focusable[0];

    return drawer;
  }
// Initializes accessibility features for drawer elements
  function createDrawerA11yController(options) {
    options = options || {};
    var drawers = (options.drawers || []).filter(Boolean);
    // If no drawers provided, guess based on common selectors
    var root =
      options.root ||
      document.querySelector('.ln-ellen') ||
      document.querySelector('#PageContainer') ||
      document.body;
      // Check for inert support 
    var supportsInert = 'inert' in HTMLElement.prototype;
    // Maps to store trigger elements and keydown handlers for each drawer
    var triggerMap = new Map();
    // Map to store keydown handlers for each drawer to allow proper cleanup
    var keydownMap = new Map();
    // Snapshot of elements that were modified to restore their state later
    var inertSnapshot = [];
    // Ensure the live region is created and available for announcements
    var liveRegion = ensureLiveRegion();
// Store the trigger element for a drawer to restore focus later
    function setTrigger(drawer, trigger) {
      if (!drawer) return;
      var normalized = normalizeTrigger(trigger);
      if (normalized && typeof normalized.focus === 'function') {
        triggerMap.set(drawer, normalized);
      }
    }
// Collects all elements that should be hidden/inert when a drawer is active
    function collectBackgroundTargets(activeDrawer) {
      var targets = [];
      var seen = new Set();
// Helper function to add elements to the targets list while applying necessary filters
      function pushTarget(element) {
        // Skip if element is null, already processed, the active drawer itself, the live region, or elements that contain either
        if (!element || seen.has(element)) return;
        // Skip if element is the active drawer, the live region, or contains either to avoid hiding necessary content
        if (element === activeDrawer) return;
        // Skip if element is the live region or contains the live region to ensure announcements are still accessible
        if (element === liveRegion || element.id === LIVE_REGION_ID) return;
        // Skip if element contains the active drawer or the live region to avoid hiding necessary content
        if (element.contains(activeDrawer) || element.contains(liveRegion)) return;
        // Skip if element is a backdrop or non-interactive content to avoid unnecessary processing
        if (element.classList && element.classList.contains('offcanvas-backdrop')) return;
        // Skip if element is a script, style, or template tag to avoid unnecessary processing
        if (element.tagName === 'SCRIPT' || element.tagName === 'STYLE' || element.tagName === 'TEMPLATE') return;
        seen.add(element);
        targets.push(element);
      }
      // Traverse up from the active drawer to the root collecting siblings 
      var node = activeDrawer;
      while (node && node !== root && node.parentElement) {
        Array.prototype.slice.call(node.parentElement.children).forEach(function (sibling) {
          if (sibling !== node) pushTarget(sibling);
        });
        node = node.parentElement;
      }
      
      if (node === root) {
        if (root !== document.body) {
          Array.prototype.slice.call(document.body.children).forEach(function (element) {
            if (element === root) return;
            pushTarget(element);
          });
        }
      } else {
        Array.prototype.slice.call(root.children).forEach(pushTarget);
        if (root !== document.body) {
          Array.prototype.slice.call(document.body.children).forEach(function (element) {
            if (element === root) return;
            pushTarget(element);
          });
        }
      }

      return targets;
    }
// Remove aria-hidden to all background elements to isolate the active drawer
    function clearBackgroundIsolation() {
      inertSnapshot.forEach(function (entry) {
        if (!entry.element || !document.contains(entry.element)) return;
        if (entry.usedInert) {
          entry.element.inert = entry.previousInert;
        }
        if (entry.previousAriaHidden === null) {
          entry.element.removeAttribute('aria-hidden');
        } else {
          entry.element.setAttribute('aria-hidden', entry.previousAriaHidden);
        }
      });
      inertSnapshot = [];
    }
// Apply aria-hidden to background elements to ensure focus and screen reader isolation
    function applyBackgroundIsolation(activeDrawer) {
      clearBackgroundIsolation();
      var targets = collectBackgroundTargets(activeDrawer);
      inertSnapshot = targets.map(function (element) {
        // Store the previous state of the element to restore later
        return {
          element: element,
          previousAriaHidden: element.getAttribute('aria-hidden'),
          previousInert: supportsInert ? Boolean(element.inert) : false,
          usedInert: supportsInert
        };
      });
// Apply inert or aria-hidden to each target element to hide it from assistive technologies
      targets.forEach(function (element) {
        if (supportsInert) {
          element.inert = true;
        } else {
          element.setAttribute('aria-hidden', 'true');
        }
      });
    }
// Keyboard navigation and focus trapping within the active drawer
    function trapFocus(drawer, event) {
      // Handle Escape key to close the drawer
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        var offcanvas = window.bootstrap && window.bootstrap.Offcanvas
          ? window.bootstrap.Offcanvas.getOrCreateInstance(drawer)
          : null;
        if (offcanvas) offcanvas.hide();
        return;
      }
      // Only trap Tab key for focus navigation
      if (event.key !== 'Tab') return;
      var focusable = getFocusableElements(drawer);
      if (!focusable.length) {
        event.preventDefault();
        drawer.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;
      // If focus moves outside the drawer, bring it back to the first or last element based on Shift key
      if (!drawer.contains(active)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
        return;
      }
      // If Shift+Tab on the first element, move focus to the last element
      if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
        return;
      }
      // If Tab on the last element, move focus to the first element
      if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    }
// Restore focus to the trigger element or fallback when drawer is closed
    function restoreFocus(drawer) {
      var trigger = triggerMap.get(drawer);
      triggerMap.delete(drawer);

      if (trigger && document.contains(trigger) && typeof trigger.focus === 'function' && isVisible(trigger)) {
        trigger.focus();
        return;
      }
      // Fallback: focus the first focusable element outside of any visible drawer
      var fallback = getFocusableElements(document.body).find(function (element) {
        return !element.closest('.offcanvas.show');
      });

      if (fallback) fallback.focus();
    }
// Event handlers for drawer 
    function onShow(event) {
      var drawer = event.target;
      var trigger = event.relatedTarget || document.activeElement;
      setTrigger(drawer, trigger);
    }
// After the drawer shown, apply background isolation and focus trap
    function onShown(event) {
      var drawer = event.target;
      applyBackgroundIsolation(drawer);
      // Create and store the keydown handler for focus trapping
      var keydownHandler = function (keyboardEvent) {
        trapFocus(drawer, keyboardEvent);
      };

      keydownMap.set(drawer, keydownHandler);
      drawer.addEventListener('keydown', keydownHandler);
    // Ensure the drawer itself is focusable to receive focus if no other focusable elements are present to focus the focus on the drawer as a fallback for focus trapping
      if (!drawer.hasAttribute('tabindex')) {
        drawer.setAttribute('tabindex', '-1');
      }
      // Focus the initial target after the drawer is shown to ensure it receives focus properly
      window.requestAnimationFrame(function () {
        var target = getInitialFocusTarget(drawer);
        if (target && typeof target.focus === 'function') {
          target.focus();
        }
      });
      // Announce the drawer opening using the live region for screen readers
      var announcement =
        drawer.getAttribute('data-drawer-open-announcement') ||
        (drawer.getAttribute('aria-label')
          ? drawer.getAttribute('aria-label') + ' opened'
          : 'Drawer opened');
      announce(announcement);
    }
// After the drawer hidden, clear background isolation and focus trap
    function onHidden(event) {
      var drawer = event.target;
      var keydownHandler = keydownMap.get(drawer);
      if (keydownHandler) {
        drawer.removeEventListener('keydown', keydownHandler);
        keydownMap.delete(drawer);
      }
      //
      var visibleDrawer = drawers.find(function (node) {
        return node !== drawer && node.classList.contains('show');
      });

      if (visibleDrawer) {
        applyBackgroundIsolation(visibleDrawer);
        return;
      }

      clearBackgroundIsolation();
      restoreFocus(drawer);
    }
    // Initialize each drawer element with  ARIA  and event listeners
    drawers.forEach(function (drawer) {
      if (!drawer.hasAttribute('role')) drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      if (!drawer.hasAttribute('tabindex')) drawer.setAttribute('tabindex', '-1');
      drawer.addEventListener('show.bs.offcanvas', onShow);
      drawer.addEventListener('shown.bs.offcanvas', onShown);
      drawer.addEventListener('hidden.bs.offcanvas', onHidden);
    });
// Return the controller object  methods: announce messages, set trigger elements, destroy the controller
    return {
      announce: announce,
      setTrigger: setTrigger,
      destroy: function () {
        clearBackgroundIsolation();
        // Remove all event listeners and clear maps to clean up the controller
        drawers.forEach(function (drawer) {
          drawer.removeEventListener('show.bs.offcanvas', onShow);
          drawer.removeEventListener('shown.bs.offcanvas', onShown);
          drawer.removeEventListener('hidden.bs.offcanvas', onHidden);
          var keydownHandler = keydownMap.get(drawer);
          if (keydownHandler) drawer.removeEventListener('keydown', keydownHandler);
        });
        keydownMap.clear();
        triggerMap.clear();
      }
    };
  }
// Expose the controller to the global scope 
  window.LnDrawerA11yController = {
    create: createDrawerA11yController,
    announce: announce
  };
})();
